<swiper-container appSwiper [config]="config" init="false" pagination="true">
  @for (promo of promotions; track promo) {
    <swiper-slide class="img-shimmer" (click)="openPromotion(promo)">
      <img class="swiper-slide" [defaultImage]="'/assets/images/item-placeholder.png'" [lazyLoad]="promo.image" [errorImage]="'/assets/images/item-placeholder.png'"/>
    </swiper-slide>
  }
</swiper-container>
